// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import Label from "../../../components/label";
import Iconify from "../../../components/iconify";
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  // blog: icon('ic_blog'),
  home: <Iconify icon={"akar-icons:home"} />,
  agent: <Iconify icon={"hugeicons:robot-01"} />,
  chats: <Iconify icon={"si:chat-line"} />,
  settings: <Iconify icon={"solar:settings-linear"} />,
  calendar: <Iconify icon={"solar:calendar-linear"} />,
  restaurant: <Iconify icon={"ic:outline-delivery-dining"} />,
  instance: <Iconify icon={"ic:round-whatsapp"} />,
  brain1: <Iconify icon={"hugeicons:ai-brain-04"} />,
  assistantConfig: <Iconify icon={"hugeicons:ai-setting"} />,
  sale: <Iconify icon={"ic:round-point-of-sale"} />,
  clients: <Iconify icon={"humbleicons:users"} />,
  users: <Iconify icon={"hugeicons:user-settings-01"} />,
  campaign: <Iconify icon={"solar:bolt-linear"} />,
  wallet: <Iconify icon={"solar:wallet-money-linear"} />,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      { title: "Home", path: PATH_DASHBOARD.general.home, icon: ICONS.home },
      // { title: 'Agente', path: PATH_DASHBOARD.general.admins, icon: ICONS.agent },
      {
        title: "Whatsapp",
        path: PATH_DASHBOARD.general.instance,
        icon: ICONS.instance,
        roles: ["whatsapp"],
      },
      {
        title: "Conversas",
        path: PATH_DASHBOARD.general.chats,
        icon: ICONS.chats,
        roles: ["chats"],
      },
      {
        title: "Contatos",
        path: PATH_DASHBOARD.general.contacts,
        icon: ICONS.clients,
        roles: ["contacts"],
      },
      {
        title: "Base de conhecimento",
        path: PATH_DASHBOARD.general.knowledgeBase,
        icon: ICONS.brain1,
        roles: ["knowledgeBase"],
      },
      {
        title: "Disparos",
        path: PATH_DASHBOARD.broadcasts.root,
        icon: ICONS.campaign,
        roles: ["broadcastsCampaignList", "broadcastsFollowUpList"],
        children: [
          {
            title: "Campanhas",
            path: PATH_DASHBOARD.campaign.list,
            roles: ["broadcastsCampaignList"],
          },
          {
            title: "Follow up",
            path: PATH_DASHBOARD.followUp.list,
            roles: ["broadcastsFollowUpList"],
          },
        ],
      },
      {
        title: "Alfred Studio",
        path: PATH_DASHBOARD.general.assistantConfig,
        icon: ICONS.assistantConfig,
        roles: ["assistantConfig"],
      },
      // {
      //   title: "PDV",
      //   path: PATH_DASHBOARD.general.pdv,
      //   icon: ICONS.sale,
      // },
      // { title: 'Definições gerais', path: PATH_DASHBOARD.general.users, icon: ICONS.settings },
    ],
  },
  {
    subheader: "Modulos",
    items: [
      {
        title: "Agendamentos",
        path: PATH_DASHBOARD.general.schedule,
        icon: ICONS.calendar,
        roles: ["scheduleCalendar"],
      },
      {
        title: "Delivery",
        path: PATH_DASHBOARD.delivery.root,
        icon: ICONS.restaurant,
        roles: ["restaurantDashboard", "restaurantOrders"],
        children: [
          {
            title: "Dashboard",
            path: PATH_DASHBOARD.delivery.dashboard,
            roles: ["restaurantDashboard"],
          },
          {
            title: "Pedidos",
            path: PATH_DASHBOARD.delivery.orders,
            roles: ["restaurantOrders"],
          },
        ],
      },
    ],
  },
  {
    subheader: "Configurações",
    items: [
      {
        title: "Usuários",
        path: PATH_DASHBOARD.users.list,
        icon: ICONS.clients,
        blockForSubUser: true,
      },
      {
        title: "Carteira",
        path: PATH_DASHBOARD.wallet.root,
        icon: ICONS.wallet,
        blockForSubUser: true,
      },
    ],
    bottom: true
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     // USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.new },
  //         { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
  //         { title: 'account', path: PATH_DASHBOARD.user.account },
  //       ],
  //     },

  //     // E-COMMERCE
  //     {
  //       title: 'ecommerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //       ],
  //     },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

  //     // BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.blog.new },
  //       ],
  //     },
  //     {
  //       title: 'File manager',
  //       path: PATH_DASHBOARD.fileManager,
  //       icon: ICONS.folder,
  //     },
  //   ],
  // },

  // // APP
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: <Label color="error">+32</Label>,
  //     },
  //     {
  //       title: 'chat',
  //       path: PATH_DASHBOARD.chat.root,
  //       icon: ICONS.chat,
  //     },
  //     {
  //       title: 'calendar',
  //       path: PATH_DASHBOARD.calendar,
  //       icon: ICONS.calendar,
  //     },
  //     {
  //       title: 'kanban',
  //       path: PATH_DASHBOARD.kanban,
  //       icon: ICONS.kanban,
  //     },
  //   ],
  // },

  // // DEMO MENU STATES
  // {
  //   subheader: 'Other cases',
  //   items: [
  //     {
  //       // default roles : All roles can see this entry.
  //       // roles: ['user'] Only users can see this item.
  //       // roles: ['admin'] Only admin can see this item.
  //       // roles: ['admin', 'manager'] Only admin/manager can see this item.
  //       // Reference from 'src/guards/RoleBasedGuard'.
  //       title: 'item_by_roles',
  //       path: PATH_DASHBOARD.permissionDenied,
  //       icon: ICONS.lock,
  //       roles: ['admin'],
  //       caption: 'only_admin_can_see_this_item',
  //     },
  //     {
  //       title: 'menu_level',
  //       path: '#/dashboard/menu_level',
  //       icon: ICONS.menuItem,
  //       children: [
  //         {
  //           title: 'menu_level_2a',
  //           path: '#/dashboard/menu_level/menu_level_2a',
  //         },
  //         {
  //           title: 'menu_level_2b',
  //           path: '#/dashboard/menu_level/menu_level_2b',
  //           children: [
  //             {
  //               title: 'menu_level_3a',
  //               path: '#/dashboard/menu_level/menu_level_2b/menu_level_3a',
  //             },
  //             {
  //               title: 'menu_level_3b',
  //               path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b',
  //               children: [
  //                 {
  //                   title: 'menu_level_4a',
  //                   path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4a',
  //                 },
  //                 {
  //                   title: 'menu_level_4b',
  //                   path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4b',
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       title: 'item_disabled',
  //       path: '#disabled',
  //       icon: ICONS.disabled,
  //       disabled: true,
  //     },

  //     {
  //       title: 'item_label',
  //       path: '#label',
  //       icon: ICONS.label,
  //       info: (
  //         <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
  //           NEW
  //         </Label>
  //       ),
  //     },
  //     {
  //       title: 'item_caption',
  //       path: '#caption',
  //       icon: ICONS.menuItem,
  //       caption:
  //         'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
  //     },
  //     {
  //       title: 'item_external_link',
  //       path: 'https://www.google.com/',
  //       icon: ICONS.external,
  //     },
  //     {
  //       title: 'blank',
  //       path: PATH_DASHBOARD.blank,
  //       icon: ICONS.blank,
  //     },
  //   ],
  // },
];

export default navConfig;
